var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "editor-row customize-editor-minimize" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v(_vm._s(_vm.$t("auto.stringFormatterReplaceFindPattern"))),
        ]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "Enter the pattern to find",
            "show-attributes": true,
            "show-emoji": false,
            "automation-mode": "",
          },
          model: {
            value: _vm.clone.replace.pattern,
            callback: function ($$v) {
              _vm.$set(_vm.clone.replace, "pattern", $$v)
            },
            expression: "clone.replace.pattern",
          },
        }),
        _vm._v(" "),
        _c("small", { staticClass: "description" }, [
          _vm._v(
            _vm._s(
              _vm.$t(
                "auto.stringFormatterReplaceEnterTheRegularExpressionOrTextToSearchFor"
              )
            )
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row customize-editor-minimize" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v(_vm._s(_vm.$t("auto.stringFormatterReplaceReplaceWith"))),
        ]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "Enter the replacement text",
            "show-attributes": true,
            "show-emoji": false,
            "automation-mode": "",
          },
          model: {
            value: _vm.clone.replace.replacement,
            callback: function ($$v) {
              _vm.$set(_vm.clone.replace, "replacement", $$v)
            },
            expression: "clone.replace.replacement",
          },
        }),
        _vm._v(" "),
        _c("small", { staticClass: "description" }, [
          _vm._v(
            _vm._s(
              _vm.$t(
                "auto.stringFormatterReplaceEnterTheTextThatWillReplaceTheFoundPattern"
              )
            )
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row customize-editor-minimize" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v(_vm._s(_vm.$t("auto.stringFormatterReplaceFlags"))),
        ]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder:
              "Regular expression flags (e.g. 'g' for global, 'i' for case insensitive)",
            "show-attributes": true,
            "show-emoji": false,
            "automation-mode": "",
          },
          model: {
            value: _vm.clone.replace.flags,
            callback: function ($$v) {
              _vm.$set(_vm.clone.replace, "flags", $$v)
            },
            expression: "clone.replace.flags",
          },
        }),
        _vm._v(" "),
        _c("small", { staticClass: "description" }, [
          _vm._v(
            _vm._s(
              _vm.$t(
                "auto.stringFormatterReplaceOptionalRegexFlagsGGlobalICaseInsensitiveMMultilineEtc"
              )
            )
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row customize-editor-minimize" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v(
            _vm._s(_vm.$t("auto.stringFormatterReplaceReplaceAllOccurrences"))
          ),
        ]),
        _vm._v(" "),
        _c("a-switch", {
          model: {
            value: _vm.clone.replace.all,
            callback: function ($$v) {
              _vm.$set(_vm.clone.replace, "all", $$v)
            },
            expression: "clone.replace.all",
          },
        }),
        _vm._v(" "),
        _c("small", { staticClass: "description" }, [
          _vm._v(
            _vm._s(
              _vm.$t(
                "auto.stringFormatterReplaceWhenEnabledAllOccurrencesWillBeReplaced"
              )
            )
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }